(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rotating-arc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rotating-arc-component')) {
    class RotatingArcComponent extends HTMLElement {
      connectedCallback() {
        this.disc = this.querySelector('.rotating-arc__disc');
        this.viewport = this.querySelector('.rotating-arc__viewport');
        if (!this.disc) return;
        this.originals = Array.from(this.disc.children);
        this.handleResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => {
            // Mobile browsers fire resize when the URL bar collapses/expands
            // while scrolling — a height-only change. Relaying out would
            // restart the spin animation, and the arc geometry only depends
            // on width, so skip those.
            if (window.innerWidth === this.layoutWidth) return;
            this.layout();
          }, 150);
        };
        window.addEventListener('resize', this.handleResize);
        requestAnimationFrame(() => this.layout());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimer);
      }

      layout() {
        this.layoutWidth = window.innerWidth;

        // Pick the radius for the current viewport; layout() reruns on resize,
        // so crossing the breakpoint re-resolves it. The CSS transforms read
        // --arc-radius, so the inline value set here must stay in sync with
        // the radius used for the angle math below.
        const mobileRadius = parseFloat(this.dataset.radiusMobile);
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const chosenRadius = isMobile && mobileRadius ? mobileRadius : parseFloat(this.dataset.radius);
        const radius = Math.max(chosenRadius || 1600, 100);
        this.style.setProperty('--arc-radius', radius + 'px');
        const gap = parseFloat(this.dataset.gap) || 0;
        const speed = Math.max(parseFloat(this.dataset.speed) || 60, 1);
        const MAX_ITEMS = 200;

        this.disc.querySelectorAll('[data-arc-clone]').forEach((el) => el.remove());
        const items = this.originals.filter((el) => el.isConnected);
        if (!items.length) return;

        // Measure in the flat flex-row state
        this.disc.classList.remove('rotating-arc__disc--positioned');
        items.forEach((el) => el.style.removeProperty('width'));
        const sizes = items.map((el) => ({
          w: Math.max(el.offsetWidth, 1),
          h: Math.max(el.offsetHeight, 1),
        }));
        const maxHeight = Math.max(...sizes.map((s) => s.h));

        // Lock the measured width so percentage-based image widths don't
        // re-resolve against the full-width disc once positioned
        items.forEach((el, i) => {
          el.style.width = sizes[i].w + 'px';
        });

        // Angle between consecutive item centers so the straight-line gap holds
        const steps = items.map((_, i) => {
          const next = sizes[(i + 1) % sizes.length];
          return ((sizes[i].w + next.w) / 2 + gap) / radius;
        });
        const setAngle = steps.reduce((sum, a) => sum + a, 0);

        // Repeat the set until the circle is filled, then scale spacing so the
        // loop closes exactly (seamless rotation with no seam gap)
        const maxSets = Math.max(1, Math.floor(MAX_ITEMS / items.length));
        const sets = Math.min(Math.max(1, Math.ceil((Math.PI * 2) / setAngle)), maxSets);
        const scale = (Math.PI * 2) / (setAngle * sets);

        const all = [...items];
        for (let s = 1; s < sets; s++) {
          for (const el of items) {
            const clone = el.cloneNode(true);
            clone.setAttribute('data-arc-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            for (const node of [clone, ...clone.querySelectorAll('[data-block-id], [id]')]) {
              node.removeAttribute('data-block-id');
              node.removeAttribute('id');
            }
            this.disc.appendChild(clone);
            all.push(clone);
          }
        }

        let angle = 0;
        all.forEach((el, i) => {
          el.style.setProperty('--arc-angle', angle.toFixed(5) + 'rad');
          angle += steps[i % steps.length] * scale;
        });

        // Viewport height matches the crest item; the arc's drop toward the
        // edges intentionally runs past the bottom and gets clipped
        this.style.setProperty('--arc-max-item-height', Math.ceil(maxHeight) + 'px');
        this.style.setProperty('--arc-height', Math.ceil(maxHeight) + 'px');
        this.style.setProperty('--arc-duration', ((Math.PI * 2 * radius) / speed).toFixed(1) + 's');
        this.disc.classList.add('rotating-arc__disc--positioned');
      }
    }
    customElements.define('rotating-arc-component', RotatingArcComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-highlight-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-highlight-text')) {
    class ScrollHighlightText extends HTMLElement {
      connectedCallback() {
        this.#refresh();
        // A separate mobile text copy can swap in at the breakpoint, so
        // re-resolve which copy drives the animation when it flips
        this.#mobileQuery.addEventListener('change', this.#onBreakpointChange);
        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.#onSectionLoad);
        }
      }

      disconnectedCallback() {
        if (this.#onLoad) window.removeEventListener('load', this.#onLoad);
        document.removeEventListener('shopify:section:load', this.#onSectionLoad);
        this.#squeezeQuery.removeEventListener('change', this.#onLayoutChange);
        this.#mobileQuery.removeEventListener('change', this.#onBreakpointChange);
        if (this.#trigger) this.#trigger.kill();
      }

      #mobileQuery = window.matchMedia('(max-width: 749px)');
      #onBreakpointChange = () => this.#refresh();

      #onLoad = null;
      #trigger = null;
      #units = [];
      #litCount = -1;
      #stickers = new Map();
      #usedStickers = new Set();
      #tokenSplitter = /(\[[a-zA-Z0-9_-]+\])/;
      // Editor edits morph the section DOM in place without reconnecting
      // this element, so re-run on section load
      #onSectionLoad = (event) => {
        if (event.target instanceof HTMLElement && event.target.contains(this)) this.#refresh();
      };

      #refresh() {
        this.#prepare();

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.#light(1);
          return;
        }

        if (window.gsap && window.ScrollTrigger) {
          this.#init();
        } else if (document.readyState === 'complete') {
          // GSAP disabled in theme settings — show the text fully lit
          this.#light(1);
        } else if (!this.#onLoad) {
          this.#onLoad = () => (window.gsap && window.ScrollTrigger ? this.#init() : this.#light(1));
          window.addEventListener('load', this.#onLoad, { once: true });
        }
      }
      // On desktop the theme scrolls .page-wrapper, not the window (see scroll-container.js)
      #squeezeQuery = window.matchMedia('(min-width: 990px)');
      #onLayoutChange = () => this.#init();

      #scroller() {
        if (this.#squeezeQuery.matches) {
          return document.querySelector('.page-wrapper') ?? window;
        }
        return window;
      }

      #prepare() {
        const contents = Array.from(this.querySelectorAll('.scroll-highlight-text__content'));
        if (!contents.length) return;

        // Detect the split by its spans, not a flag: editor edits can morph
        // the DOM back to its server-rendered (unsplit) state in place
        const unsplit = contents.filter((el) => !el.querySelector('.sht-unit'));
        if (unsplit.length) {
          this.#stickers = new Map(
            Array.from(this.querySelectorAll('.scroll-highlight-text__stickers [data-sticker-key]')).map(
              (el) => [el.dataset.stickerKey, el]
            )
          );
          this.#usedStickers = new Set();

          // Keys match bracketed ([gummy]) or bare (gummy), longest key first
          const keys = Array.from(this.#stickers.keys())
            .filter(Boolean)
            .sort((a, b) => b.length - a.length)
            .map((key) => key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
          this.#tokenSplitter = keys.length
            ? new RegExp(`(\\[[a-zA-Z0-9_-]+\\]|\\b(?:${keys.join('|')})\\b)`, 'i')
            : /(\[[a-zA-Z0-9_-]+\])/;

          unsplit.forEach((el) => this.#splitWords(el, this.dataset.split === 'characters'));
        }

        // With a separate mobile copy, only the breakpoint-visible one drives
        // the animation; the hidden copy's units would skew the progress count
        const visible = contents.find((el) => getComputedStyle(el).display !== 'none') ?? contents[0];
        this.#units = Array.from(visible.querySelectorAll('.sht-unit'));
        this.#litCount = -1;
      }

      #init() {
        if (!this.#units.length) return;

        gsap.registerPlugin(ScrollTrigger);

        if (this.#trigger) this.#trigger.kill();
        this.#litCount = -1;

        const start = parseInt(this.dataset.start, 10) || 85;
        const end = parseInt(this.dataset.end, 10) || 45;

        this.#trigger = ScrollTrigger.create({
          trigger: this,
          scroller: this.#scroller(),
          start: `top ${start}%`,
          end: `bottom ${end}%`,
          onUpdate: (self) => this.#light(self.progress),
          onRefresh: (self) => this.#light(self.progress),
        });

        this.#squeezeQuery.removeEventListener('change', this.#onLayoutChange);
        this.#squeezeQuery.addEventListener('change', this.#onLayoutChange);
      }

      // Moves the sticker element into the text; clones it if the key is reused
      #takeSticker(key) {
        const source = this.#stickers.get(key);
        if (!source) return null;
        const sticker = this.#usedStickers.has(key) ? source.cloneNode(true) : source;
        this.#usedStickers.add(key);
        sticker.classList.add('sht-unit');
        return sticker;
      }

      #light(progress) {
        // Re-split if a DOM morph replaced the spans since the last update
        if (this.#units.length && !this.#units[0].isConnected) this.#prepare();
        const count = Math.round(progress * this.#units.length);
        if (count === this.#litCount) return;
        this.#units.forEach((unit, i) => unit.classList.toggle('is-lit', i < count));
        this.#litCount = count;
      }

      // Wraps each word in a span (and each character in a nested span when
      // perCharacter), preserving inline elements like <strong> and <a>
      #splitWords(node, perCharacter) {
        Array.from(node.childNodes).forEach((child) => {
          if (child.nodeType === Node.ELEMENT_NODE) {
            this.#splitWords(child, perCharacter);
            return;
          }
          if (child.nodeType !== Node.TEXT_NODE || !child.textContent.trim()) return;

          const fragment = document.createDocumentFragment();
          // [key] placeholders are replaced by their sticker; a bare key keeps
          // the word and renders its sticker just before it
          child.textContent.split(this.#tokenSplitter).forEach((segment) => {
            if (!segment) return;

            const bracket = segment.match(/^\[([a-zA-Z0-9_-]+)\]$/);
            if (bracket) {
              const sticker = this.#takeSticker(bracket[1].toLowerCase());
              if (sticker) {
                fragment.appendChild(sticker);
                return;
              }
            } else {
              const sticker = this.#takeSticker(segment.toLowerCase());
              if (sticker) fragment.appendChild(sticker);
            }

            segment.split(/(\s+)/).forEach((part) => {
              if (!part) return;
              if (!part.trim()) {
                fragment.appendChild(document.createTextNode(part));
                return;
              }
              const word = document.createElement('span');
              word.className = 'sht-word';
              if (perCharacter) {
                for (const char of part) {
                  const unit = document.createElement('span');
                  unit.className = 'sht-unit';
                  unit.textContent = char;
                  word.appendChild(unit);
                }
              } else {
                word.classList.add('sht-unit');
                word.textContent = part;
              }
              fragment.appendChild(word);
            });
          });
          child.replaceWith(fragment);
        });
      }
    }

    customElements.define('scroll-highlight-text', ScrollHighlightText);
  }
  } catch(e) { console.error(e); }
})();

})();
